
export enum Language {
    LANGUAGE_UNSPECIFIED = 0,
    ZH = 1, /* 中文 */
    EN = 2, /* 英文 */
}

export enum Gender {
    GENDER_UNSPECIFIED = 0,
    FEMALE = 1,
    MALE = 2,
}

